import React, { useEffect, useState } from "react";
import { Question, Rating } from "../types";
import { FaStar } from "react-icons/fa";
import { deleteSurveyQuestion } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { useAppDispatch, useAppSelector } from "../store/store";
import RatingForm from "./RatingForm";
import { updateQuestionResponse } from "../store/features/CompleteSurveySlice";
import QuestionContainer from "./QuestionResponseContainer";

interface RatingPreviewDisplayProps {
    question: Question;
    questionText: string;
    questionBody: Rating;
}

export default (props: RatingPreviewDisplayProps) => {

    const { question, questionText, questionBody } = props;
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ rating, setRating ] = useState<number>(0);

    useEffect(() => {   
        dispatch(updateQuestionResponse({questionId:question.id, response:rating}))
    }, [rating]);

    const generateStars = () => {
        const stars = [];
        for (let i = 0; i < questionBody.max; i++) {
            stars.push(
                <button onClick={() => setRating(i + 1)} key={i} className={`text-xl ${rating - 1 >= i ? 'text-[#3da8e2]' : 'text-slate-500'}`}>
                    <FaStar className="md:text-4xl"/>
                </button>
            );
        }
        return stars;
    };

    return (
        <QuestionContainer question={question}>
            <div className="flex flex-col">
                <div className="flex justify-between w-full md:w-1/4">
                    {generateStars()}
                </div>
            </div>
        </QuestionContainer>
    )
}